export const MODALS = {
  STATS: 'modal-stats',
  ACHIEVEMENTS: 'modal-achievements',
  RECENT_ACTIVITY: 'modal-recent-activity',
  REFERRAL: 'modal-referral',
  SETTINGS: 'modal-settings',
  WITHDRAW: 'modal-withdraw',
  DEPOSIT: 'modal-deposit',
  ROLLS_HOW_IT_WORKS: 'modal-rolls-how-it-works',
  ROLLS_ROUND_DETAIL: 'modal-rolls-round-detail',
  JETTON_HOW_IT_WORKS: 'modal-jetton-how-it-works',
  JETTON_ROUND_DETAIL: 'modal-jetton-round-detail',
  PROVABLY_FAIR: 'modal-provably-fair',
  WINNER_POPUP: 'modal-winner-popup',
  EDIT_QUICK_BUY: 'modal-edit-quick-buy',
  AUTOPLAY: 'modal-autoplay',
  GIFT_SELECT: 'modal-gift-select',
} as const;

export type ModalId = (typeof MODALS)[keyof typeof MODALS];
